// views/Dashboard/PainelExecutivo/components/AbasAreas.tsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import { AREAS, caminhoDaArea } from '../types';

// Cada área é um link de verdade (/dashboard/painel-executivo/financeiro), não
// um estado interno: dá para favoritar, mandar o link pronto para alguém e usar
// o botão voltar do navegador.
//
// ⚠️ Destinos ABSOLUTOS, via `caminhoDaArea` — link relativo empilha segmento
// aqui dentro. O porquê está em `types.ts`, junto de CAMINHO_PAINEL.
const AbasAreas: React.FC = () => (
  <nav aria-label="Áreas do painel" className="-mx-4 px-4 overflow-x-auto border-b border-gray-200 dark:border-gray-700">
    <div className="flex items-center gap-1 min-w-max">
      {AREAS.map((a) => (
        <NavLink
          key={a.id}
          to={caminhoDaArea(a.id)}
          end={a.id === 'visao-geral'}
          title={a.descricao}
          className={({ isActive }) =>
            `relative px-4 py-3 text-sm font-semibold whitespace-nowrap transition-colors border-b-2 -mb-px ${
              isActive
                ? 'border-primary text-primary'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600'
            }`
          }
        >
          {a.label}
        </NavLink>
      ))}
    </div>
  </nav>
);

export default AbasAreas;
